export default __webpack_public_path__ + "static/media/tiffi3big.b1184e36.jpg";